import axios from 'axios';

const GPM_API_BASE_URL= "https://rpmapi.makebettinggreat.com/v1/";
const AGP_API_BASE_URL = "https://rdbwebapi.makebettinggreat.com/v1/"
const ENDPOINT_ODDS = AGP_API_BASE_URL + 'horse/odds/';
const API_WINNER = GPM_API_BASE_URL + 'horse/winners/';
const API_VOLUME_MATCHED = GPM_API_BASE_URL + 'horse/volumematched/';
const ENDPOINT_REPORT_ALL = AGP_API_BASE_URL +'race/detail/report/';
const ENDPOINT_ODDS_GPM = GPM_API_BASE_URL + 'horse/odds/';
const RACE_URL = "https://rdbwebapi.makebettinggreat.com/v1/race/"
const RACE_DETAIL_URL = "https://rdbwebapi.makebettinggreat.com/v1/race/"
const RACE_DETAIL_URL_ALL = "https://rdbwebapi.makebettinggreat.com/v1/runner/all/"

export const getAllReport = async (date) => {
    const url = ENDPOINT_REPORT_ALL + date
    try {
        const result = await axios.get(url)
        const data = result.data
        if(result.status === 200) {
            return data;
        }else {
            return []
        }
    } catch (err) {
        console.error('getAllReport failed:', url, err);
        return [];
    }
}

export const getRaceDetails = async (race) => {
    const url = RACE_DETAIL_URL + race.raceId + "/" + race.date + "/runner"
    try {
        const result = await axios.get(url)
        const data = result.data
        if(result.status === 200) {
            return data;
        }else {
            return []
        }
    } catch (err) {
        console.error('getRaceDetails failed:', url, err);
        return [];
    }
}

export const getMatchPrediction = async (raceId, date) => {
    const url = "https://rdbwebapi.makebettinggreat.com/v1/race/" + raceId + "/" + date + "/prediction"
    try {
        const result = await axios.get(url)
        const data = result.data
        if(result.status === 200) {
            return data;
        }else {
            return []
        }
    } catch (err) {
        console.error('getMatchPrediction failed:', url, err);
        return [];
    }
}


export const getRaceSummary = async (race) => {
    const url = RACE_DETAIL_URL + race.trackId + "/race/" + race.raceTime + "/summary"
    try {
        const result = await axios.get(url)
        const data = result.data
        if(result.status === 200) {
            return data;
        }else {
            return []
        }
    } catch (err) {
        console.error('getRaceSummary failed:', url, err);
        return [];
    }
}

export const getAllRaceDetails = async (date) => {
    const url = RACE_DETAIL_URL_ALL + date;
    try {
        const result = await axios.get(url)
        const data = result.data
        if(result.status === 200) {
            return data;
        }else {
            return []
        }
    } catch (err) {
        console.error('getAllRaceDetails failed:', url, err);
        return [];
    }
}

function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    return [year, month, day].join('');
}

export const getAllRaces = async (date) => {
    const url = RACE_URL + date;
    try {
        const result = await axios.get(url)
        const data = result.data
        if(result.status === 200) {
            return data;
        }else {
            return []
        }
    } catch (err) {
        console.error('getAllRaces failed:', url, err);
        return [];
    }
}

export const getRunnerOddsByMarketId = async (marketId, selectionId, date) => {
    let endpoint = formatDate(new Date()) === date ?  ENDPOINT_ODDS_GPM : ENDPOINT_ODDS;
    const url = endpoint + marketId + "/" + selectionId;
    try {
        const result = await axios.get(url)
        const data = result.data
        if(result.status === 200) {
            return data;
        }else {
            return []
        }
    } catch (err) {
        console.error('getRunnerOddsByMarketId failed:', url, err);
        return [];
    }
}


export const getWinnerInfo = async (marketId, date, time) => {
    const endpoint = API_WINNER + date + "/"+ time +"/"  + marketId
    try {
        const result = await axios.get(endpoint)
        const data = result.data
        if(result.status === 200) {
            return data;
        }else {
            return []
        }
    } catch (err) {
        console.error('getWinnerInfo failed:', endpoint, err);
        return [];
    }
}

export const getVolumeMatched = async (marketId) => {
    const endpoint = API_VOLUME_MATCHED + marketId
    try {
        const result = await axios.get(endpoint)
        const data = result.data
        if(result.status === 200) {
            return data;
        }else {
            return []
        }
    } catch (err) {
        console.error('getVolumeMatched failed:', endpoint, err);
        return [];
    }
}

export const getMatchesByDate = async date => {
        return []
}
